import { useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const useRouter = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  return useMemo(() => {
    return {
      navigate,
      pathname: location.pathname,
      params,
      location,
      state: location.state,
    };
  }, [params, navigate, location]);
};
